import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "@/pages/login/ui/login-page";

const LoginRoute = () => {
  return <LoginPage />;
};

export const Route = createFileRoute("/auth/")({
  component: LoginRoute,
});
